export default "__VITE_ASSET__718996a5__"